/*
 * Copyright (c) 2017 Payoneer Germany GmbH. All rights reserved.
 */

const rootScopeService = require('../root-scope.service');
const windowData = require('../window-data.service');
const { getDimensionClass } = require('./utils');
var lightbox = require('../../../templates').lightbox;

/**
 * Creates the Lightbox view and appends to the document
 * Lightbox contains an overlay, overlay content and the iframe
 * Overlay covers the entire page and dims the background which has the payment page
 * Overlay content is the white background in the centre of the overlay
 * The iframe has the handler page. The handler page has the 3DS2 challenge content
 * @param {String} redirectUrl the url to be redirected to
 * @param {Object} challengeWindowSize the dimension object of the lightbox window
 */
function openLightbox(redirectUrl, challengeWindowSize) {
    const isMobile = rootScopeService.isMobile();
    const dimensionClass = getDimensionClass(challengeWindowSize && challengeWindowSize.value, windowData, isMobile);
    const element = lightbox({
        dimensionClass,
        redirectUrl,
        logoUrl: document.querySelector('label img.active')?.src,
    });
    document.body.insertAdjacentHTML('beforeend', element);
    const iframe = document.getElementById('lb-iframe');
    iframe.addEventListener('load', function () {
        const loader = document.getElementById('lb-overlay-loader');
        const hide = 'op-payment-widget-hide';
        if (!loader?.classList.contains(hide)) loader?.classList.add(hide);
    });
}

/**
 * removes the lightbox from the page
 */
function removeLightbox() {
    var element = document.getElementById('lb-overlay');
    if (element) element.remove();
}

module.exports = {
    openLightbox,
    removeLightbox,
};
